import ES20AbiImport from "./ERC20.abi.json";
export const abi = ES20AbiImport;

export * from "./ERC20";
